import axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios';
import config from '../config/ConfigProvider';

const baseApiUrl = (url: string) => `${config.value('baseApiUrl')}${url}`;

const authUrl = (url: string) => `${config.value('authUrl')}${url}`;

const authentication = {
  refreshToken(refreshParams: unknown): Promise<AxiosResponse> {
    return axios.post(authUrl(`v2/token`), refreshParams, {
      refreshToken: true,
      headers: { 'Content-type': 'application/x-www-form-urlencoded' },
    } as AxiosRequestConfig);
  },

  getToken(tokenParams: unknown): Promise<AxiosResponse> {
    return axios.post(authUrl(`v2/token`), tokenParams, {
      headers: { 'Content-type': 'application/x-www-form-urlencoded' },
    });
  },

  getUserData(): AxiosPromise {
    return axios.get(baseApiUrl(`v2/user`));
  },

  getUserInfo(): AxiosPromise {
    return axios.get(authUrl(`v1/userInfo`));
  },
};
export default authentication;
